export const converterConstants = {
    TOGGLE_CONVERT_PAYROLL_MODAL: "TOGGLE_CONVERT_PAYROLL_MODAL",
    TOGGLE_PAYROLL_DOWNLOAD_LINK_MODAL: "TOGGLE_PAYROLL_DOWNLOAD_LINK_MODAL",
    UPLOAD_PAYROLL_FILE_REQUEST: "UPLOAD_PAYROLL_FILE_REQUEST",
    UPLOAD_PAYROLL_FILE_SUCCESS: "UPLOAD_PAYROLL_FILE_SUCCESS",
    UPLOAD_PAYROLL_FILE_FAILURE: "UPLOAD_PAYROLL_FILE_FAILURE",

    TOGGLE_QR_CODE_MONKEY_IMPORT_MODAL: "TOGGLE_QR_CODE_MONKEY_IMPORT_MODAL",
    UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_REQUEST: "UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_REQUEST",
    UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_SUCCESS: "UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_SUCCESS",
    UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_FAILURE: "UPLOAD_QR_CODE_MONKEY_IMPORT_FILE_FAILURE",

};
